import { Component, Input, OnInit } from '@angular/core';
import { ResponseData } from 'src/app/service/model/response.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IncomePerMonthPopupComponent } from '../../chart-popup/income-per-month-popup/income-per-month-popup.component';
@Component({
  selector: 'app-income-per-month-yearly',
  templateUrl: './income-per-month-yearly.component.html',
  styleUrls: ['./income-per-month-yearly.component.scss']
})
export class IncomePerMonthYearlyComponent {
  @Input() item!: ResponseData;
  currentYear = new Date("YYYY");

  // public barChartOptions: any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
  public barChartOptions: any = {
  scaleShowVerticalLines: false,
  responsive: true,
  // NEW: tooltip formatting to append "AED" to values
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
      
        const usFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
 
            
        // Prefix with dataset label if present, then value + " AED"
        const dsLabel = data.datasets[tooltipItem.datasetIndex]?.label || '';
        // const value = tooltipItem.xLabel; // horizontalBar uses xLabel for value
        const value = usFormatter.format(tooltipItem.yLabel); // VerticalBar uses yLabel for value
        // If you want only "765 AED" without dataset name, return `${value} AED`
         return dsLabel ? `${dsLabel}: ${value} AED` : `${value} AED`;
       
      }
    }
  }
};

  chartData: number[] = [];
  public barChartLabels: string[] = []
  public barChartData: any[] = [];

  public barChartType: string = 'bar';
  //public barChartLegend:boolean = true;

  public barChartColors: Array<any> = [
    {
      backgroundColor: '#74acac',
      borderColor: '#346d68',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }
  ];
  constructor(private modalService: NgbModal) { }

  ngAfterViewInit() {
    this.CreateChart();
  }

  CreateChart() {
    for (let i = 0; i < this.item.data.dashboardIncomePerMonthChart.length; i++) {

      this.barChartLabels.push(this.item.data.dashboardIncomePerMonthChart[i].monthName)
      this.chartData.push(this.item.data.dashboardIncomePerMonthChart[i].totalAmount)
    }   
    this.barChartData = [{ data: this.chartData, label: (new Date()).getFullYear() }];
    
  }


  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

   OpenPopUp()
    {  
            const modalRef = this.modalService.open(IncomePerMonthPopupComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
            (modalRef.componentInstance as IncomePerMonthPopupComponent).defaultChartData=this.item.data.dashboardIncomePerMonthChart;
            
              modalRef.result.then((result) => {
                console.log(result);
              });
          
    } 
}
